/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {finishInstantPayDirectDepositSwitch} from '../api'

export const useMutationFinishInstantPayDirectDepositSwitch = createReactQueryMutationHook('finishInstantPayDirectDepositSwitch', finishInstantPayDirectDepositSwitch)
